import gql from 'graphql-tag'
import { customerFragment } from '@/graphql/customer/customerFragments'
import { customerContactFragment } from '@/graphql/customer/customerContactFragments'
import { customerLocationFragment } from '@/graphql/customer/customerLocationFragments'

export const CUSTOMERS = gql`
    query customers(
        $ids: [ID]
        $page: Int
        $first: Int
        $trashed: Trashed
    ) {
        customers(
            ids: $ids
            page: $page
            first: $first
            trashed: $trashed
        ){
            data{
                ...customerFragment
                contacts {
                    data {
                        ...customerContactFragment
                    }
                }
                locations {
                    data {
                        ...customerLocationFragment
                    }
                }
            }
        }
    }
    ${customerFragment}
    ${customerContactFragment}
    ${customerLocationFragment}
`
export const CUSTOMERSSEARCH = gql`
    query customersSearch(
        $searchText: String = null
        $page: Int
        $first: Int
    ) {
        customersSearch(
            searchText: $searchText
            page: $page
            first: $first
        ){
            data{
                ...customerFragment
                contacts {
                    data {
                        ...customerContactFragment
                    }
                }
                locations {
                    data {
                        ...customerLocationFragment
                    }
                }
            }
        }
    }
    ${customerFragment}
    ${customerContactFragment}
    ${customerLocationFragment}
`
export const CUSTOMERSLIST = gql`
    query customers(
        $ids: [ID]
        $page: Int
        $first: Int
        $trashed: Trashed
    ) {
        customers(
            ids: $ids
            page: $page
            first: $first
            trashed: $trashed
        ){
            data{
                ...customerFragment
            }
        }
    }
    ${customerFragment}
`
export const CUSTOMERSLISTSEARCH = gql`
    query customersSearch(
        $searchText: String = null
        $page: Int
        $first: Int
    ) {
        customersSearch(
            searchText: $searchText
            page: $page
            first: $first
        ){
            data{
                ...customerFragment
            }
        }
    }
    ${customerFragment}
`
export const CONTACTS = gql`
    query contacts(
        $ids: [ID]
        $customer_id: ID
        $customer_ids: [ID]
        $page: Int
        $first: Int = 250
        $trashed: Trashed
    ) {
        contacts(
            ids: $ids
            customer_id: $customer_id
            customer_ids: $customer_ids
            page: $page
            first: $first
            trashed: $trashed
        ){
            data{
                ...customerContactFragment
            }
        }
    }
    ${customerContactFragment}
`
export const CONTACTSFULL = gql`
    query contacts(
        $ids: [ID]
        $customer_id: ID
        $customer_ids: [ID]
        $page: Int
        $first: Int = 250
        $trashed: Trashed
    ) {
        contacts(
            ids: $ids
            customer_id: $customer_id
            customer_ids: $customer_ids
            page: $page
            first: $first
            trashed: $trashed
        ){
            data{
                ...customerContactFragment
                customer(trashed: WITH) {
                
                    ...customerFragment
                }
            }
        }
    }
    ${customerContactFragment}
    ${customerFragment}
`
export const CONTACTSSEARCH = gql`
    query contactsSearch(
        $searchText: String
        $page: Int
        $first: Int
    ) {
        contactsSearch(
            searchText: $searchText
            page: $page
            first: $first
        ){
            data{
                ...customerContactFragment
            }
        }
    }
    ${customerContactFragment}
`
export const CONTACTSSEARCHFULL = gql`
    query contactsSearch(
        $searchText: String
        $page: Int
        $first: Int
    ) {
        contactsSearch(
            searchText: $searchText
            page: $page
            first: $first
        ){
            data{
                ...customerContactFragment
                customer {
                    ...customerFragment
                }
            }
        }
    }
    ${customerContactFragment}
    ${customerFragment}
`

export const LOCATIONS = gql`
    query locations(
        $ids: [ID]
        $customer_id: ID
        $customer_ids: [ID]
        $page: Int
        $first: Int
        $trashed: Trashed
    ) {
        locations(
            ids: $ids
            customer_id: $customer_id
            customer_ids: $customer_ids
            page: $page
            first: $first
            trashed: $trashed
        ){
            data{
                ...customerLocationFragment
            }
        }
    }
    ${customerLocationFragment}
`
export const LOCATIONSSEARCH = gql`
    query locationsSearch(
        $searchText: String
        $page: Int
        $first: Int
    ) {
        locationsSearch(
            searchText: $searchText
            page: $page
            first: $first
        ){
            data{
                ...customerLocationFragment
            }
        }
    }
    ${customerLocationFragment}
`